<template>
  <div class="" @click="printCV()">
    <div class="xhani"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    printCV: function () {
      window.print()
    },
  },
}
</script>

<style lang="scss"></style>
